export default __webpack_public_path__ + "static/media/正版.633f5aff.svg";